import React, { ReactElement } from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import NavRoutes from '../../constants/NavRoutes';
import { BASE_ROUTE, PATIENT_BASE_ROUTE } from '../../constants/BaseRoute';
interface RouteComponentProps extends RouteProps {
  isUserAuthenticated: boolean;
  component: React.ComponentType<any>;
}

const PrivateRoute = ({
  component: Component,
  isUserAuthenticated,
  ...rest
}: RouteComponentProps): ReactElement => {
  return (
    <Route
      {...rest}
      render={props => {
        if (isUserAuthenticated) {
          return <Component {...rest} {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: `/${BASE_ROUTE}/${NavRoutes.PUBLIC.LOGIN}`,
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};

const PublicRoute = ({
  component: Component,
  isUserAuthenticated,
  ...rest
}: RouteComponentProps): ReactElement => {
  return (
    <Route
      {...rest}
      render={props => {
        if (!isUserAuthenticated) {
          return <Component {...rest} {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: `/${BASE_ROUTE}/${NavRoutes.PRIVATE.HOME}`,
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};

const PatientPrivateRoute = ({
  component: Component,
  isUserAuthenticated,
  ...rest
}: RouteComponentProps): ReactElement => {
  return (
    <Route
      {...rest}
      render={props => {
        if (isUserAuthenticated) {
          return <Component {...rest} {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: `/${PATIENT_BASE_ROUTE}/${NavRoutes.PUBLIC[404]}`,
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};

const PatientPublicRoute = ({
  component: Component,
  isUserAuthenticated,
  ...rest
}: RouteComponentProps): ReactElement => {
  return (
    <Route
      {...rest}
      render={props => {
        if (!isUserAuthenticated) {
          return <Component {...rest} {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: `/${PATIENT_BASE_ROUTE}/${NavRoutes.PRIVATE.PATIENT.DOCUMENTS}/${NavRoutes.PRIVATE.PATIENT.UPLOAD_CARDS}`,
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};

export { PrivateRoute, PublicRoute, PatientPrivateRoute, PatientPublicRoute };
